import * as React from "react";

import StrategyDetail from "../../Strategies/StrategyDetail";

export type WorkspaceStrategyDrawerContentProps = {
  strategyId: string;
  onDeleted?: () => void;
  onClose?: () => void;
};

export function WorkspaceStrategyDrawerContent({
  strategyId,
  onDeleted,
  onClose,
}: WorkspaceStrategyDrawerContentProps): React.ReactElement {
  return (
    <div data-workspace-strategy-drawer="" className="flex min-h-full min-w-0 flex-1 flex-col">
      <StrategyDetail
        layout="embedded"
        strategyId={strategyId}
        onDeleted={onDeleted}
        onClose={onClose}
      />
    </div>
  );
}
